"use client";

import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import "./AIBenefitsSection.scss";
import { Container } from "react-bootstrap";

const AIBenefitsSection = ({ benefits } = {}) => {
  const sectionRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const items = benefits?.benefitsData || [];
  const title = benefits?.title || "Benefits of AI Implementation";

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % items.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [items.length]);

  return (
    <section ref={sectionRef} className="ai-benefits-section">
      <Container>
        <div className="ai-benefits-sticky">
          <div className="ai-benefits-container">
            {/* LEFT SIDE */}
            <div className="ai-benefits-left">
              <div className="ai-ring-system">
                <div className="ring ring-1"></div>
                <div className="ring ring-2"></div>
                <div className="ring ring-3"></div>
                <div className="ring ring-4"></div>
                <div className="ring ring-5"></div>
              </div>

              <div className="ai-center-circle">
                <h2 className="ai-center-title">{title}</h2>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="ai-benefits-right">
              {items.map((item, idx) => {
                const isActive = activeIndex === idx;

                return (
                  <motion.div
                    key={idx}
                    className={`ai-benefit-item ${
                      isActive ? "active" : "inactive"
                    }`}
                    animate={
                      isMobile
                        ? {
                            opacity: 1,
                            filter: "blur(0px)",
                            scale: 1,
                          }
                        : {
                            opacity: isActive ? 1 : 0.28,
                            filter: isActive ? "blur(0px)" : "blur(1.5px)",
                            scale: isActive ? 1.06 : 0.92,
                          }
                    }
                    transition={{
                      duration: isMobile ? 0 : 1.1,
                      ease: [0.22, 1, 0.36, 1],
                    }}
                  >
                    {/* DOT */}
                    <div className="ai-item-dot-container">
                      <motion.div
                        className="ai-item-dot"
                        animate={
                          isMobile
                            ? {
                                scale: 1,
                                boxShadow: "0 0 0px rgba(255,95,87,0)",
                              }
                            : {
                                scale: isActive ? [1, 1.2, 1] : 0.7,
                                boxShadow: isActive
                                  ? [
                                      "0 0 0px rgba(255,95,87,0.2)",
                                      "0 0 25px rgba(255,95,87,0.5)",
                                      "0 0 0px rgba(255,95,87,0.2)",
                                    ]
                                  : "0 0 0px rgba(255,95,87,0)",
                              }
                        }
                        transition={{
                          duration: 2,
                          repeat: isMobile ? 0 : isActive ? Infinity : 0,
                          ease: "easeInOut",
                        }}
                      />
                    </div>

                    {/* TEXT */}
                    <div className="ai-item-content">
                      <h3 className="ai-item-number">{item.section}</h3>

                      <div className="ai-item-text">
                        <h4 className="ai-item-title">{item.title}</h4>

                        {/* <p className="ai-item-description">
                          {item.description}
                        </p> */}
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AIBenefitsSection;
